var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H70L80 10V80H0V0Z",
    fill: "#5490F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4663 66.6668H31.1108V57.778H13.333V17.778H33.333V22.2224H17.7775V53.3335H35.5552V61.3113L43.533 53.3335H62.2219V40.0002H66.6663V57.778H45.3552L36.4663 66.6668Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0005 35.5556H37.7783V13.3334H60.0005V16.4L61.6894 15.5556H66.6672V33.3334H61.6894L60.0005 32.4889V35.5556ZM42.2228 31.1112H55.5561V25.2889L62.2228 28.6223V20.2667L55.5561 23.6V17.7778H42.2228V31.1112Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamZoom);
export default __webpack_public_path__ + "static/media/team_zoom.0209d24ce0d343e4ef9bcf8222071ade.svg";
export { ForwardRef as ReactComponent };